import * as React from "react";
import { Container, Row, Col } from 'reactstrap';
import { Tooltip, Icon, Breadcrumb, Input, Button, AutoComplete, Select, DatePicker } from 'antd';
import moment from 'moment';
import { INFO_POINTS_EDITION } from "../infoPointsConstants";

const { Option } = Select;
const { TextArea } = Input;

export class HandleEditionRender extends React.Component {

    mandatoryField(value) {
        if (value) { // icon error
            return (<Tooltip title="This field is mandatory"><Icon type="exclamation-circle" style={{ left: '0px', marginLeft: '10px', top: "8px" }} /></Tooltip>)
        }
        else { //icon ok
            return (<Icon type="check-circle" style={{ left: '0px', marginLeft: '10px', top: "8px" }} />)
        }
    }

    render() {

        const { editions, magazines, edition, activeMagazine, activeEdition, editionSaved } = this.props.data;
        const { handleMagazine, handleParent, focusParent, editionNameWritten, magazineNameWritten, handleNumberChange, handleDescriptionChange, onCompetenceFromChange, onCompetenceToChange, editEdition, saveEdition, handleClear } = this.props.func;
        
        let listaEdition = editions.map(edt =>
            <Option key={edt.id}>{edt.number}</Option>
        )

        let listaMagazine = magazines.map(mgz =>
            <Option key={mgz.id}>{mgz.name}</Option>
        )

        let activeSaveButton = edition.magazineId && edition.number && edition.competenceDateFrom && edition.competenceDateTo ? true : false;

        let saveButtonSwitch = edition.id ? <Button disabled={!activeSaveButton} onClick={editEdition} className="saveButtonHrWizard" icon="save" >Update</Button> : <Button disabled={!activeSaveButton} onClick={saveEdition} className="saveButtonHrWizard" icon="save">Save</Button>

        return (this.props &&

            <Row style={{ width: '100%' }}>
                <Col style={{ minHeight: '50vh' }} sm='12'>
                    <div className="wizardFields wizardContacts" style={{ minHeight: '50vh' }}>
                        <div className="wizardBackground createCat" style={{ height: 'inherit' }}>
                            <div className="modifyHrBox" style={{ width: '100%' }}>
                                <div className={"modifyHr" + editionSaved} style={{ width: '100%' }}>
                                    <Row>
                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_EDITION.MAGAZINE}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Magazine:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex', position: "relative" }}>
                                                <AutoComplete
                                                    dataSource={listaMagazine}
                                                    value={activeMagazine}
                                                    placeholder="Magazine"
                                                    style={{ width: '100%' }}
                                                    onSelect={handleMagazine}
                                                    onSearch={magazineNameWritten}
                                                    filterOption={(inputValue, option) =>
                                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                />
                                                {activeMagazine && (<Icon type="close" className="iconClose" onClick={() => handleClear("magazine")} />)}
                                                {this.mandatoryField(!edition.magazineId)}
                                            </div>
                                        </Col>

                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_EDITION.EDITION_NUMBER}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Edition Number:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Input autoComplete="new-password" type="number" style={{ width: '100%' }} className="contactText hrNameValidation" allowClear={true} placeholder="Edition number" value={edition.number} onChange={handleNumberChange} />

                                                {this.mandatoryField(!edition.number)}
                                            </div>
                                        </Col>

                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_EDITION.PARENT_EDITION}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Parent Edition:</h4>
                                                </Tooltip>
                                            </div>
                                            <div style={{ width: '100%', display: 'inline-flex', position: "relative", paddingRight: 25 }}>
                                                <AutoComplete
                                                    dataSource={listaEdition}
                                                    value={activeEdition}
                                                    placeholder="Parent Edition"
                                                    onBlur={focusParent}
                                                    style={{ width: '100%' }}
                                                    onSelect={handleParent}
                                                    onSearch={editionNameWritten}
                                                    filterOption={(inputValue, option) =>
                                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                    }
                                                />

                                                {activeEdition && (<Icon type="close" className="iconClose" onClick={() => handleClear("parentedition")} />)}
                                            </div>
                                        </Col>

                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_EDITION.RELEVANT_PERIOD_START}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Relevant period (start):</h4>
                                                </Tooltip>
                                            </div>

                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    className="endDatePicker fullWidthPicker"
                                                    placeholder="DD/MM/YYYY"
                                                    value={edition.competenceDateFrom ? moment(edition.competenceDateFrom) : null}
                                                    onChange={onCompetenceFromChange}
                                                />

                                                {this.mandatoryField(!edition.competenceDateFrom)}
                                            </div>
                                        </Col>

                                        <Col sm="4">
                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <Tooltip placement="topLeft" title={INFO_POINTS_EDITION.RELEVANT_PERIOD_END}>
                                                    <h4 style={{ width: 'auto' }}><Icon type="info-circle" /> Relevant period (end):</h4>
                                                </Tooltip>
                                            </div>

                                            <div style={{ width: '100%', display: 'inline-flex' }}>
                                                <DatePicker
                                                    format="DD/MM/YYYY"
                                                    className="endDatePicker fullWidthPicker"
                                                    placeholder="DD/MM/YYYY"
                                                    value={edition.competenceDateTo ? moment(edition.competenceDateTo) : null}
                                                    onChange={onCompetenceToChange}
                                                />

                                                {this.mandatoryField(!edition.competenceDateTo)}
                                            </div>
                                        </Col>

                                        <Col sm="12">
                                            <Tooltip placement="topLeft" title={INFO_POINTS_EDITION.DESCRIPTION}>
                                                <h4 id="h4Desc" className="mt-20">
                                                    <Icon type="info-circle" /> Description:
                                                </h4>
                                            </Tooltip>
                                            <TextArea className="textareaWizard" autosize={{ minRows: 1, maxRows: 15 }} style={{ width: '100%' }} placeholder="Description" value={edition.description} onChange={handleDescriptionChange} />
                                        </Col>
                                    </Row>

                                    <div className="buttonHandleEdition">
                                        {saveButtonSwitch}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }

}



// WEBPACK FOOTER //
// ./src/FileMaker/Editions/HandleEditionRender.js